import moment from 'moment'
import modelIcon from '@/assets/icons/icon_mx.png'
import creatorIcon from '@/assets/icons/icon_creator.png'
import softwareIcon from '@/assets/icons/icon_3d.png'
import textIcon from '@/assets/icons/icon_text.png'
import videoIcon from '@/assets/icons/icon_sp.png'
import audioIcon from '@/assets/icons/icon_yp.png'
import imageIcon from '@/assets/icons/icon_pic.png'

export function listRowEvenColor (record, index) {
  if (index % 2 !== 0) {
    return {
      style: {
        background: '#FAFAFA'
      }
    }
  }
}
export function downloadFile (url) {
  const link = document.createElement('a')
    // 设置下载的文件名
    link.download = url.substring(url.lastIndexOf('/') + 1, url.length)
    link.style.display = 'none'
    link.setAttribute('target', '_blank')
    // 设置下载路径
    link.href = url
    // 触发点击
    document.body.appendChild(link)
    link.click()
    // 移除节点
    document.body.removeChild(link)
}

// 文件大小格式转换
export function formatFileSize (size) {
  if (size < 1024) {
    return size + 'B'
  } else if (size < 1024 * 1024) {
    return (size / 1024).toFixed(2) + 'KB'
  } else if (size < 1024 * 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + 'MB'
  } else {
    return (size / 1024 / 1024 / 1024).toFixed(2) + 'GB'
  }
}

export function checkImgFile (file) {
  const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length)
  const isJPG = fileType === 'jpg' || fileType === 'png' || fileType === 'jpeg'
  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isJPG) {
    this.$message.error('上传头像图片只能是 JPG/PNG/JPEG 格式!')
  }
  if (!isLt2M) {
    this.$message.error('上传头像图片大小不能超过 2MB!')
  }
  return isJPG && isLt2M
}

export function computedTime(time) {
  const d = Math.floor(time / 60 / 60 / 24)
  const h = Math.floor(time / 60 / 60 % 24)
  const m = Math.floor(time / 60 % 60)
  const html = d > 0 ? d + '天' + h + '时' + m + '分' : h > 0 ? h + '时' + m + '分' : m + '分'
  const obj = {
    time: html,
    minute: m
  }
  return obj
}

export function computedLessonStatus(start, end) {
  const obj = {
    status: 1,
    minute: {
      time: undefined,
      minute: 0
    }
  }
  const currentTime = new Date().getTime() / 1000
  const startTime = start.includes('-')
    ? new Date(start).getTime() / 1000
    : new Date(moment().format('YYYY-MM-DD ') + start).getTime() / 1000
  const endTime = end.includes('-')
    ? new Date(end).getTime() / 1000
    : new Date(moment().format('YYYY-MM-DD ') + end).getTime() / 1000
  // 当前时间超出课程结束时间
  if (currentTime >= endTime) {
    obj.status = 99
  } else if (startTime > currentTime) {
    // 当前时间小于课程开始时间
    const computedTime = startTime - currentTime
    const d = Math.floor(computedTime / 60 / 60 / 24)
    const h = Math.floor(computedTime / 60 / 60 % 24)
    const m = Math.ceil(computedTime / 60 % 60)
    const html = d > 0 ? d + ' 天 ' + h + ' 小时 ' + m + ' 分钟' : h > 0 ? h + ' 小时 ' + m + ' 分钟' : m + ' 分钟'
    obj.status = 1
    obj.minute = {
      time: html,
      minute: m
    }
  } else {
    // 当前时间大于课程开始时间，小于课程结束时间
    obj.status = 50
  }
  return obj
}

export function getListIndex(arr, page, pageSize) {
  const list = arr.map((item, index) => {
    const obj = { ...item }
    obj.index = (page - 1) * pageSize + (index + 1)
    return obj
  })
  return list
}

// 获取类型Icon
export function getIcon(type) {
  /**
   * model: 模型
   * software: 软件
   * text: 文本
   * video：视频
   * audio：音频
   * image: 图片
   * */
  const typeMap = {
    text: textIcon,
    model: modelIcon,
    video: videoIcon,
    audio: audioIcon,
    image: imageIcon,
    creator: creatorIcon,
    software: softwareIcon
  }
  // console.log(obj)
  return typeMap[type]
}
